import { openSurfacePrintDialog } from 'owa-calendar-module-commanding';
import { ControlIcons } from 'owa-control-icons';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import loc from 'owa-localize';
import { calendarPrintPanelPrintLabel } from 'owa-locstrings/lib/strings/calendarprintpanelprintlabel.locstring.json';

export function getSurfacePrintMenuItem() {
    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(calendarPrintPanelPrintLabel),
        [FilterableMenuItemArgs.icon]: ControlIcons.Print,
        [FilterableMenuItemArgs.onClick]: openSurfacePrintDialog,
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
    });
}
